<template>
  <div v-if="!!orderSummary?.length" class="bg-white px-4 py-3 border-t border-b border-cart-gray  z-2">
    <div class="font-niceone-bold pb-1.25 tracking-wide text-primary">{{ $t('cart.order_summary') }}</div>
    <div v-for="(item) in orderSummary" :key="item?.code" class="flex items-center justify-between">
      <div class="tracking-wide md:text-[13px]" v-html="item?.title"/>
      <niceone-price :price="item?.text" html-text class="!-mt-1"></niceone-price>
    </div>
  </div>
</template>

<script setup>
import {useCartStore} from "@/store/cart";

const cartStore = useCartStore()
const {cart} = storeToRefs(cartStore)

const orderSummary = computed(() => cart.value?.order_summary)
</script>
<style>

</style>